import NavigableValidation from '~/models/navigableValidations/navigableValidation'
import ProcessFlowStep from '~/models/processFlows/processFlowStep'

export default class ProcessFlowStepValidation<T extends ProcessFlowStep> extends NavigableValidation<ProcessFlowStep> {
  validators = []
}